import { Box, ColumnConfig, DataTable, Text } from "grommet";
import React, { useEffect, useRef } from "react";
import Utility from "../../../../../../../util/api/Utility";
import StandardColors from "../../../../../../../util/StandardColors";
import "./ItemListCard.css";
import { useStore } from "../../../../../../../Hooks/useStore";
import { observer } from 'mobx-react';

type ItemListCardPropsType<T> = {
  title: string;
  data: T[];
  columns: ColumnConfig<T>[];
};

function ItemListCard<T>({ title, data, columns }: ItemListCardPropsType<T>) {
  const { rootStore } = useStore();
  const tableRef = useRef(null);
  const handleResize = (value: any) => {
    const newHeight = value[0].contentRect.height;
    const newStep = Math.ceil((newHeight - 160) / 38);
    rootStore.adminStore.handleStep(newStep);
  }
  useEffect(() => {
    const obserResize = new ResizeObserver(handleResize);

    if (tableRef.current) {
      obserResize.observe(tableRef.current);
    }
    return () => {
      obserResize.disconnect();
    }
  },[]);
  return (
    <Box
      elevation="xsmall"
      fill
      round="small"
      direction="column"
      align="center"
      className="list-container"
      background={StandardColors.white}
      ref={tableRef}
    >
      <p className="card-title-text">{title}</p>
      {data.length == 0 ? (
        <Box fill align="center" justify="center">
          <Text color={"black_20"}>No medical emergencies yet.</Text>
        </Box>
      ) : (
        <DataTable
          fill
          data={data}
          resizeable
          columns={columns}
          step={rootStore.adminStore.getSteps}
          border={"bottom"}
          paginate
          sortable
        />
      )}
    </Box>
  );
}

export default observer(ItemListCard);
